(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7616],{

/***/ 47805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup",
      function () {
        return __webpack_require__(82101);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);



var ReCaptchaWrapper = function(param) {
    var children = param.children, recaptchaActive = param.recaptchaActive, recaptchaKey = param.recaptchaKey;
    if (!+recaptchaActive) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_recaptcha_v3__WEBPACK_IMPORTED_MODULE_2__/* .ReCaptchaProvider */ .dR, {
        useEnterprise: true,
        reCaptchaKey: recaptchaKey,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ReCaptchaWrapper);


/***/ }),

/***/ 82101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ signup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 30 modules
var MainLayout = __webpack_require__(23095);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
// EXTERNAL MODULE: ./atoms/Toast/useToast.ts
var useToast = __webpack_require__(54213);
// EXTERNAL MODULE: ./atoms/index.ts + 1 modules
var atoms = __webpack_require__(69607);
// EXTERNAL MODULE: ./atoms/customFields/TextField.tsx
var TextField = __webpack_require__(14125);
// EXTERNAL MODULE: ./atoms/customFields/TextArea.tsx
var TextArea = __webpack_require__(9881);
// EXTERNAL MODULE: ./atoms/customFields/DropDown.tsx
var DropDown = __webpack_require__(38334);
// EXTERNAL MODULE: ./atoms/customFields/DateField.tsx
var DateField = __webpack_require__(5740);
// EXTERNAL MODULE: ./atoms/customFields/YesNoRadio.tsx
var YesNoRadio = __webpack_require__(2296);
// EXTERNAL MODULE: ./atoms/customFields/RadioButton.tsx
var RadioButton = __webpack_require__(18581);
// EXTERNAL MODULE: ./atoms/customFields/SelectField.tsx
var SelectField = __webpack_require__(95415);
// EXTERNAL MODULE: ./components/account/account.module.scss
var account_module = __webpack_require__(67707);
var account_module_default = /*#__PURE__*/__webpack_require__.n(account_module);
// EXTERNAL MODULE: ./node_modules/next-recaptcha-v3/lib/index.js + 5 modules
var lib = __webpack_require__(69498);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
;// CONCATENATED MODULE: ./components/account/AccountPageLogin.tsx























var AccountPageLogin = function(param) {
    var breadcrumb = param.breadcrumb, customFieldGenerate = param.customFieldGenerate, translationsData = param.translationsData, recaptchaActive = param.recaptchaActive, dbName = param.dbName;
    var ref = (0,react.useState)({
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        re_token: "",
        first_name: "",
        last_name: ""
    }), savedFormData = ref[0], setSavedFormData = ref[1];
    var ref1 = (0,react.useState)({
        email: "",
        password: "",
        password_confirmation: "",
        phone: "",
        re_token: ""
    }), formErrors = ref1[0], setFormErrors = ref1[1];
    var ref2 = (0,react.useState)(true), urlValidate = ref2[0], setUrlValidate = ref2[1];
    var ref3 = (0,react.useState)(false), isSubmitted = ref3[0], setIsSubmitted = ref3[1];
    var history = (0,next_router.useRouter)();
    var toast = (0,useToast/* useToast */.p)();
    var executeRecaptcha = (0,lib/* useReCaptcha */.CL)().executeRecaptcha;
    var handleChange = function(event, code) {
        var _target = event.target, name = _target.name, value = _target.value;
        var regexDecimal = /^\d+(\.\d{0,100})?$/;
        var regexInteger = /^\d+$/;
        var regexUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
        var regexLettersOnly = /^[a-zA-Z]+$/;
        var regexLettersAndNumbersOnly = /^[a-zA-Z0-9]+$/;
        var filterValue = function() {
            if (code === "decimal" && !regexDecimal.test(value)) {
                if (regexDecimal.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "integer" && !regexInteger.test(value)) {
                if (regexInteger.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "url") {
                setUrlValidate(value !== "" ? regexUrl.test(value) : true);
            }
            if (code === "letter" && !regexLettersOnly.test(value)) {
                if (regexLettersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            if (code === "letter_number" && !regexLettersAndNumbersOnly.test(value)) {
                if (regexLettersAndNumbersOnly.test(value.slice(0, -1))) {
                    return value.slice(0, -1);
                } else {
                    return "";
                }
            }
            return value;
        };
        setSavedFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, savedFormData), (0,_define_property/* default */.Z)({}, name, filterValue())));
    };
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            var token;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e.preventDefault();
                        if (!(String(recaptchaActive) === "1")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            executeRecaptcha("form_submit")
                        ];
                    case 1:
                        token = _state.sent();
                        setSavedFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, savedFormData), {
                            re_token: token
                        }));
                        _state.label = 2;
                    case 2:
                        setIsSubmitted(true);
                        setFormErrors(validate(savedFormData));
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var validate = function(form) {
        var regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        var regexDecimal = /^\d+(\.\d+)?$/;
        var regexUrl = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
        var errors = {};
        var attributeCode = function(name) {
            return customFieldGenerate.map(function(item) {
                if (item.validation === name) {
                    return item;
                }
            }).filter(function(item) {
                return item !== undefined;
            }).map(function(elem) {
                return elem.attribute_code;
            });
        };
        if (!form.email) {
            errors.email = "This email is required";
        }
        if (!form.password_confirmation || form.password != form.password_confirmation) {
            errors.password_confirmation = "Passwords do not match";
        }
        if (!form.email || !regexEmail.test(form.email)) {
            errors.invalidEmail = "Invalid email format";
        }
        attributeCode("decimal").map(function(el) {
            if (!form[el] || !regexDecimal.test(form[el])) {
                errors[el] = "Please enter a valid decimal number";
            }
        });
        attributeCode("url").map(function(el) {
            if (!form[el] || !regexUrl.test(form[el])) {
                errors[el] = "Invalid Url format";
            }
        });
        if (!form.password || form.password.length < 6) {
            errors.password = "Password must be more than 6 characters";
        }
        return errors;
    };
    (0,react.useEffect)(function() {
        if (!Object.keys(formErrors).length && isSubmitted) {
            registerHandler();
            setIsSubmitted(false);
        }
    }, [
        formErrors
    ]);
    var registerHandler = function() {
        var options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(savedFormData)
        };
        fetch((0,helper/* apiUrlWithStore */.St)("/api/customer/register"), options).then(function(responce) {
            return responce.json();
        }).then(function(res) {
            if (res.message == "Your account has been created successfully.") {
                history.push("/");
                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                        translationsData.AccountCreateSuccess
                    ]
                }));
            } else if (res.message == "Verification mail sent.") {
                history.push("/");
                toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "d-flex chek-fms",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* CheckToastSvg */.xQ, {}),
                        translationsData.VerificationMailToast
                    ]
                }));
            } else {
                if (res.email) {
                    toast.open(/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        className: "d-flex chek-fms",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* FailSvg */.as, {}),
                            translationsData[(0,utils/* spaceToUpperCaseConvertor */.WD)(res.email[0])]
                        ]
                    }));
                }
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["card-wrapper"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (account_module_default()).card,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (account_module_default())["card-body"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (account_module_default())["card-title"],
                                        children: translationsData.SignUp
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                    inpValue: savedFormData.first_name,
                                                    name: "first_name",
                                                    handleChange: handleChange,
                                                    value: translationsData.FirstName,
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                    inpValue: savedFormData.last_name,
                                                    name: "last_name",
                                                    handleChange: handleChange,
                                                    value: translationsData.LastName,
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                    type: "number",
                                                    inpValue: savedFormData.phone,
                                                    name: "phone",
                                                    handleChange: handleChange,
                                                    value: translationsData.Phone,
                                                    required: false
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                        withStar: true,
                                                        inpValue: savedFormData.email,
                                                        name: "email",
                                                        handleChange: handleChange,
                                                        value: translationsData.Email
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "alert alert-danger p-0 m-0",
                                                        children: (formErrors === null || formErrors === void 0 ? void 0 : formErrors.email) ? translationsData.TheEmailFieldIsRequired : (formErrors === null || formErrors === void 0 ? void 0 : formErrors.invalidEmail) ? translationsData.InvalidEmailFormat : ""
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                        withStar: true,
                                                        type: "password",
                                                        name: "password",
                                                        inpValue: savedFormData.password,
                                                        handleChange: handleChange,
                                                        value: translationsData.Password
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "alert alert-danger p-0 m-0",
                                                        children: (formErrors === null || formErrors === void 0 ? void 0 : formErrors.password) && translationsData.CharactersPassword
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                        withStar: true,
                                                        type: "password",
                                                        name: "password_confirmation",
                                                        inpValue: savedFormData.password_confirmation,
                                                        handleChange: handleChange,
                                                        value: translationsData.ConfirmPassword
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "alert alert-danger p-0 m-0",
                                                        children: (formErrors === null || formErrors === void 0 ? void 0 : formErrors.password_confirmation) && translationsData.PasswordsAreNotTheSame
                                                    })
                                                ]
                                            }),
                                            customFieldGenerate.map(function(item, index) {
                                                switch(item.type){
                                                    case "textfield":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            savedFormData: savedFormData,
                                                            translationsData: translationsData,
                                                            handleChange: handleChange,
                                                            formErrors: formErrors,
                                                            urlValidate: urlValidate
                                                        });
                                                    case "textarea":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            translationsData: translationsData,
                                                            savedFormData: savedFormData,
                                                            handleChange: handleChange
                                                        });
                                                    case "dropdown":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDown/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            translationsData: translationsData,
                                                            savedFormData: savedFormData,
                                                            handleChange: handleChange
                                                        });
                                                    case "date":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DateField/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            savedFormData: savedFormData,
                                                            translationsData: translationsData,
                                                            handleChange: handleChange
                                                        });
                                                    case "boolean":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(YesNoRadio/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            translationsData: translationsData,
                                                            handleChange: handleChange
                                                        });
                                                    case "radio":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioButton/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            translationsData: translationsData,
                                                            handleChange: handleChange
                                                        });
                                                    case "multiselect":
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectField/* default */.Z, {
                                                            item: item,
                                                            index: index,
                                                            translationsData: translationsData,
                                                            handleChange: handleChange
                                                        });
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                className: "btn btn-lg btn-orange ".concat((account_module_default())["login-button"], " ", [
                                                    "rounded-pills"
                                                ], "  ").concat((account_module_default()).sbm_button),
                                                children: translationsData.Registration
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var account_AccountPageLogin = (AccountPageLogin);

// EXTERNAL MODULE: ./components/shared/ReCaptchaWrapper.tsx
var ReCaptchaWrapper = __webpack_require__(2598);
;// CONCATENATED MODULE: ./pages/signup.tsx










var Signup = function(pageProps) {
    var dbName = pageProps.dbName, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, customFieldGenerate = pageProps.customFieldGenerate, recaptchaActive = pageProps.recaptchaActive, recaptchaKey = pageProps.recaptchaKey, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var router = (0,next_router.useRouter)();
    var meta_title = translationsData.SignUp;
    var meta_description = "Sign Up page";
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReCaptchaWrapper/* default */.Z, {
        recaptchaActive: recaptchaActive,
        recaptchaKey: recaptchaKey,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                                children: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "generator",
                                content: "Zegashop.com"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "twitter:title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: meta_description
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: meta_title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:keywords",
                                content: meta_keywords
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: meta_url
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:locale",
                                content: selectedLocale
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                rel: "canonical",
                                href: meta_url
                            }),
                            (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                        hrefLang: "x-default"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                        hrefLang: defaultLangCode
                                    }),
                                    locales.map(function(intl) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                            rel: "alternate",
                                            href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                            hrefLang: intl.code
                                        });
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(account_AccountPageLogin, {
                        dbName: dbName,
                        breadcrumb: breadcrumb,
                        customFieldGenerate: customFieldGenerate,
                        translationsData: translationsData,
                        recaptchaActive: recaptchaActive
                    })
                ]
            })
        }))
    });
};
var __N_SSP = true;
/* harmony default export */ var signup = (Signup);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,1950,3997,320,7352,9774,2888,179], function() { return __webpack_exec__(47805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);